import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';

import { SearchService } from 'app/services/search/search.service';
@Component({
  selector: 'app-menuiserie',
  templateUrl: './menuiserie.component.html',
  styleUrls: ['./menuiserie.component.scss']
})
export class MenuiserieComponent implements OnInit {

  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  p: Number = 1;
  closeResult = '';
  search_name1:any;
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete= 10;
  totalSociete : any;
  public AgenciesTunis:any


  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig,
        
    private searchService: SearchService 
    ) { }

  ngOnInit() {

this.getMenuiserie();
  }

  getMenuiserie() {
    this.agenciesService.getMateriauxMenuiserie().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log("liste des équipements", this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis
      .sort((a: any, b: any) => {
        // Sort based on the existence of projets array
        if (a.produits.length === 0 && b.produits.length > 0) {
          return 1; // Move agencie with empty produits to the end
        } else if (a.produits.length > 0 && b.produits.length === 0) {
          return -1; // Move agencie with non-empty projets to the beginning
        } else {
          return 0; // No change in order
        }
      });
    });
  }
  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any) {
    this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {


      console.log(this.dataSource.data);

    
    });

    
  }
  public changePage(){
    this.lengthSociete=this.lengthSociete+10;
  }

 // Méthode pour effectuer la recherche
 performSearch() {
  this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
}
}
